import { VaMethodology } from "../../../Component/Model/Dto/VerificationAgency/VaMethodology";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { TableColumn } from "../../../Component/Model/Table/Table";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { IRowAction } from "../../../Component/Common/Components/DataTable/RowAction";
import { UserAtom } from "../../../State/user.Atom";
import { useRecoilValue } from "recoil";

interface VaMethodologyTableRow {
    requirementDescription: String,
    createdBy: String,
    active: boolean,
    actions?: IRowAction[];
}

export interface IVaMethodologyTable {
    columns: Array<TableColumn>;
    rows: Array<VaMethodologyTableRow>;
}

export function VAMethodologyTableMapper(results: VaMethodology.VaMethodologySearchResult[], filteredItemsCount : number, pageNumber : number, pageSize : number, toggleMethodology: (id: number, value: boolean) => Promise<void>, deleteMethodology: (id: number) => Promise<void>,moveUp : (id : number) => void, moveDown : (id : number) => void): IVaMethodologyTable {
    const user = useRecoilValue(UserAtom);
    
    const columns = [
        { Header: 'Requirement Description', accessor: 'requirementDescription', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="500px" />, disableSortBy: false },
        { Header: 'Create By', accessor: 'createdBy', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="500px" /> }
    ];
    
    if (user.isAdmin) {
        columns.push({ Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true });
    }

    if (results.length >= 0) {
        const rows: VaMethodologyTableRow[] = results.map((item: VaMethodology.VaMethodologySearchResult, index: number) => {
            const actions: IRowAction[] = [];

            const lastItemIndexOnPage = pageNumber > 1
            ? (pageNumber * pageSize) - pageSize - 1
            : ((pageNumber + 1) * pageSize) - 1;

            actions.push({
                onOff: true,
                key: index.toString(),
                label: 'Exclude Methodology',
                onOffState: item.enabled,
                onOffChange: (value: boolean) => (toggleMethodology(item.id, value)),
            });

            if ((index !== 0 || pageNumber !== 1) && item.enabled) {
                actions.push({
                    key: index.toString(),
                    label: 'Move up',
                    action: () => {
                        moveUp(item.id);
                    },
                    icon: {
                        color: 'primary',
                        name: 'arrow_upward'
                    },
                    onOffState: item.enabled
                });
            } else {
                actions.push({
                  key: index.toString(),
                  label: 'Unavailable',
                  action: () => {
                  },
                  icon: {
                      color: 'secondary',
                      name: 'arrow_upward'
                  },
              });
              }
            if (index !== filteredItemsCount - 1 && index !== lastItemIndexOnPage && item.enabled) {
                actions.push({
                    key: index.toString(),
                    label: 'Move down',
                    action: () => {
                        moveDown(item.id);
                    },
                    icon: {
                        color: 'primary',
                        name: 'arrow_downward'
                    },
                    onOffState: item.enabled
                });             
            } else {
                actions.push({
                  key: index.toString(),
                  label: 'Unavailable',
                  action: () => {
                  },
                  icon: {
                      color: 'secondary',
                      name: 'arrow_downward'
                  },
              });
              }
            actions.push({
                key: index.toString(),
                label: 'Delete',
                action: () => {
                    deleteMethodology(item.id);
                },
                icon: {
                    color: 'error',
                    name: 'delete'
                },
                onOffState: item.enabled
            });
            return {
                requirementDescription: item.requirementDescription,
                createdBy: item.createdBy,
                active: item.enabled,
                actions: actions
            }});

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}